// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FloatingContacts_wrapper__UULl1","button":"FloatingContacts_button__H2Q8b","whatsapp":"FloatingContacts_whatsapp__7P_fO"};